import {FeedbackRating} from "types/enums";

export interface IFeedbackState {
    rating: FeedbackRating,
    reasonGiven: boolean
}

export class MessageHistoryMessage {

    constructor(
        public sender: string,
        public senderName: string,
        public time: Date,
        public message: string,
        public messageId: string,
        public responseId: string,
        public feedbackState: IFeedbackState | null
    ) {}
}